import {
  useMutation
} from '@tanstack/vue-query'
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationReturnType
} from '@tanstack/vue-query'
import {
  unref
} from 'vue'
import type {
  MaybeRef
} from 'vue'
import type {
  BackendErrorEntity,
  SearchInterpretBodyDto,
  SearchInterpretResponseDto
} from '.././types'
import { fetchApiInstance } from '../../fetchApiInstance';
import type { ErrorType, BodyType } from '../../fetchApiInstance';


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


export const apiSearchInterpret = (
    searchInterpretBodyDto: MaybeRef<SearchInterpretBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      searchInterpretBodyDto = unref(searchInterpretBodyDto);
      
      return fetchApiInstance<SearchInterpretResponseDto>(
      {url: `/search/interpret`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: searchInterpretBodyDto
    },
      options);
    }
  


export const getApiSearchInterpretMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiSearchInterpret>>, TError,{data: BodyType<SearchInterpretBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiSearchInterpret>>, TError,{data: BodyType<SearchInterpretBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiSearchInterpret>>, {data: BodyType<SearchInterpretBodyDto>}> = (props) => {
          const {data} = props ?? {};

          return  apiSearchInterpret(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiSearchInterpretMutationResult = NonNullable<Awaited<ReturnType<typeof apiSearchInterpret>>>
    export type ApiSearchInterpretMutationBody = BodyType<SearchInterpretBodyDto>
    export type ApiSearchInterpretMutationError = ErrorType<BackendErrorEntity>

    export const useApiSearchInterpret = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiSearchInterpret>>, TError,{data: BodyType<SearchInterpretBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiSearchInterpret>>,
        TError,
        {data: BodyType<SearchInterpretBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiSearchInterpretMutationOptions(options);

      return useMutation(mutationOptions);
    }
    